// productComponents.js
(function() {
  // Convierte una URL de producto en la versión limpia y su endpoint JSON.
  const buildUrls = url => {
    const { origin, pathname } = new URL(url);
    return { cleanUrl: origin + pathname, jsonUrl: origin + pathname + ".json" };
  };

  // Genera el HTML para un producto usando template literals.
  // Los datos relevantes se guardan en data-attributes del form para facilitar el manejo en el submit.
  const generateProductHTML = ({ product, cleanUrl }) => {
    const { title, id, variants = [], images = [] } = product;
    const variant = variants[0] || {};
    const productPrice = variant.price || "";
    const productCompareAtPrice = variant.compare_at_price || "";
    const productVariantId = variant.id || "";
    const productImage = images[0]?.src || "";
    const priceHTML =
      productCompareAtPrice && parseFloat(productCompareAtPrice) > parseFloat(productPrice)
        ? `<span class="original-price" style="text-decoration: line-through; margin-right:10px;">${productCompareAtPrice} €</span>
           <span class="discounted-price">${productPrice} €</span>`
        : `${productPrice} €`;
    return `
      <div class="product-container" style="text-align:center;margin-bottom:20px;">
        <a href="${cleanUrl}">
          <img src="${productImage}" alt="${title}" class="product-image" style="display:inline-block;">
        </a>
        <a href="${cleanUrl}" class="product-name" style="display:block;text-align:center;">${title}</a>
        <p class="product-price" style="text-align:center;">${priceHTML}</p>
        <form method="post" action="/cart/add" class="product-form form" accept-charset="UTF-8" enctype="multipart/form-data" novalidate
              data-variant-id="${productVariantId}" data-product-image="${productImage}" data-product-name="${title}">
          <input type="hidden" name="form_type" value="product">
          <input type="hidden" name="utf8" value="✓">
          <input type="hidden" name="id" value="${productVariantId}" class="product-variant-id">
          <div class="product-form__buttons">
            <button id="ProductSubmitButton-template--22803638288712__main" type="submit" name="add" class="product-form__submit button button--full-width button--primary">
              <span>Agregar al carrito</span>
              <div class="loading__spinner hidden">
                <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
                  <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
                </svg>
              </div>
            </button>
          </div>
          <input type="hidden" name="product-id" value="${id}">
          <input type="hidden" name="section-id" value="template--22803638288712__main">
        </form>
      </div>
    `;
  };

  // Actualiza o crea el "punto verde" (bubble) del carrito consultando /cart.js.
  const updateCartBubble = async () => {
    try {
      const res = await fetch("/cart.js");
      if (!res.ok) throw new Error("Error fetching cart data");
      const { item_count: count } = await res.json();
      const cartIcon = document.getElementById("cart-icon-bubble");
      if (!cartIcon) return;
      let bubble = cartIcon.querySelector(".cart-count-bubble");
      const bubbleHTML = `<span aria-hidden="true">${count}</span>
                          <span class="visually-hidden">${count} artículo${count != 1 ? "s" : ""}</span>`;
      if (!bubble) {
        bubble = document.createElement("div");
        bubble.className = "cart-count-bubble";
        cartIcon.appendChild(bubble);
      }
      bubble.innerHTML = bubbleHTML;
    } catch (err) {
      console.error(err);
    }
  };

  // Función principal que carga y muestra los productos.
  async function embedProducts(productUrls, containerId = "product-components") {
    const parent = document.getElementById(containerId);
    if (!parent) return;
    try {
      const htmlArray = await Promise.all(
        productUrls.map(async url => {
          const { cleanUrl, jsonUrl } = buildUrls(url);
          const res = await fetch(jsonUrl);
          if (!res.ok) throw new Error(`Error fetching ${jsonUrl}`);
          const { product } = await res.json();
          return generateProductHTML({ product, cleanUrl });
        })
      );
      parent.innerHTML = htmlArray.join("");
    } catch (err) {
      console.error(err);
    }
  }

  // Manejo centralizado del envío de formularios mediante event delegation.
  document.addEventListener("submit", async e => {
    const form = e.target.closest("form.product-form");
    if (!form) return;
    e.preventDefault();
    const spinner = form.querySelector(".loading__spinner");
    spinner.classList.remove("hidden");
    const variantId = form.dataset.variantId;
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      spinner.classList.add("hidden");
      if (!res.ok) throw new Error("Error adding product to cart");
      await res.json();
      // Actualiza la notificación de carrito.
      const notif = document.getElementById("cart-notification");
      if (notif) {
        const notifProd = notif.querySelector("#cart-notification-product");
        if (notifProd) {
          notifProd.innerHTML = `
            <div class="cart-notification-product__image global-media-settings">
              <img src="${form.dataset.productImage}" alt="${form.dataset.productName}" width="70" height="70" loading="lazy">
            </div>
            <div>
              <h3 class="cart-notification-product__name h4">${form.dataset.productName}</h3>
              <dl></dl>
            </div>
          `;
        }
        notif.classList.add("active");
        setTimeout(() => notif.classList.remove("active"), 3000);
      }
      await updateCartBubble();
    } catch (err) {
      spinner.classList.add("hidden");
      console.error(err);
    }
  });

  // Exponemos la función globalmente para que pueda ser llamada con las URLs deseadas.
  window.embedProducts = embedProducts;
})();